import styled from "@emotion/styled";

import IconHeadphoneSvg from "./headphone.svg";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledIconHeadphoneSvg = styled(IconHeadphoneSvg)``;
